import { ReactElement } from 'react';

import { ExchangeRate } from 'modules/analytics/components/ExchangeRate';
import { TotalStaked } from 'modules/analytics/components/TotalStaked';

import { Stats } from '../components/Stats';

export function Analytics(): ReactElement {
  return (
    <div>
      <Stats />

      <TotalStaked />

      <ExchangeRate />
    </div>
  );
}
